import {
  DEFAULT_OG_IMAGE_HEIGHT,
  DEFAULT_OG_IMAGE_WIDTH,
  getSectionOgImageUrl,
} from "@config/ogImageConstants";
import { capitalize } from "@helper/stringTransform";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function VideoMetaData(section: string): PageMetaDataValues {
  const capitalizedSection = capitalize(section);

  const gaData: GADataProps = {
    level2: section,
    title: `${capitalizedSection}_Index`,
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  const metaTags: MetaTagsProps = {
    title: `${capitalizedSection}, Berita - Beritaharian.sg`,
    description:
      "Berita Harian Singapura - Tonton video mengenai Singapura, Asia dan dunia.",
    slug: `/${section}`,
    ogImage: {
      url: getSectionOgImageUrl("multimedia"),
      width: DEFAULT_OG_IMAGE_WIDTH,
      height: DEFAULT_OG_IMAGE_HEIGHT,
    },
  };

  return {
    gaData,
    metaTags,
  };
}
